import { BrainInterface, BrainResultInterface, GroupInterface, Slug } from '@swivl-mono/types';
import { APIService } from '../Service/API.Service';
// LINK apps/server/src/API/Brain/Brains.Controller.ts
export class BrainsAPI {
  static async getBrains(orgId: number) {
    return APIService.Server.get<{[slug:string]:BrainInterface}>(
      `/brains/org/${orgId}`
    );
  }
  // static async getBrainById(orgId: number, brainId: number) {
  //   return APIService.Server.get<BrainInterface>(
  //     `/brains/org/${orgId}/brain/${brainId}`
  //   );
  // }
  static async getBrainBySlug(orgId: number, slug: Slug) {
    return APIService.Server.get<BrainInterface>(
      `/brains/org/${orgId}/slug/${slug}`
    );
  }

  static async createBrain(orgId: number, brain: Partial<BrainInterface>) {
    return APIService.Server.post<BrainInterface>(
      `/brains/org/${orgId}/brain`,
      brain
    );
  }
  static async updateBrain(orgId: number, brain: BrainInterface) {
    return APIService.Server.put<BrainInterface>(
      `/brains/org/${orgId}/brain/${brain.id}`,
      brain
    );
  }
  static async deleteBrain(orgId: number, brainId: number) {
    return APIService.Server.delete(
      `/brains/org/${orgId}/brain/${brainId}`
    );
  }


  static async saveBrainResults(orgId: number,results:Partial<BrainResultInterface>) {
    return APIService.Server.post<BrainResultInterface>(
      `/brains/org/${orgId}/brain-results`,
      results
    );
  }
}
